var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPayments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 56,
    viewBox: "0 0 58 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 56,
    rx: 20,
    fill: "#04A780"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5195 27.0726H33.7245V29.2601H24.5195V27.0726ZM24.5195 31.2026H33.7245V33.3901H24.5195V31.2026ZM24.5195 22.8726H33.7245V25.0601H24.5195V22.8726Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8447 15.75L31.8697 14.49L29.1397 15.75L26.2172 14.49L23.4697 15.75L19.3047 14V42L23.4697 40.25L26.2172 41.4575L29.1397 40.25L31.8697 41.4575L34.8447 40.25L38.6947 42V14L34.8447 15.75ZM36.4897 38.6925L34.8797 37.975L31.9222 39.1825L29.1747 37.9225L26.2347 39.13L23.5222 37.9225L21.5097 38.745V17.255L23.5222 18.0775L26.2347 16.87L29.1747 18.0775L31.9222 16.87L34.8797 18.0775L36.4897 17.36V38.6925Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayments);
export default __webpack_public_path__ + "static/media/payments.62ce29c128374c42ddfb90f6744eafb8.svg";
export { ForwardRef as ReactComponent };